import { useTranslation } from '@dreamstack/i18n'
import { GoogleMap } from '@react-google-maps/api'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'
import type { LatLng } from './parseGeoLocation'

const MapPlaceholder = tw.div`relative bg-accentroGray-100 height[467px] md:(height[375px]) ml:(height[567px])`

const MyMapNonMemo: FunctionComponent<
  React.PropsWithChildren<{
    center: LatLng
    mapStyle?: google.maps.MapTypeStyle[] | null
    height?: number
    isLoaded?: boolean
  }>
> = ({ center, mapStyle, children, isLoaded }) => {
  const t = useTranslation()
  if (!isLoaded) {
    return (
      <MapPlaceholder className="google-maps">
        <div className="uc-embedding-wrapper">
          <h3>{t('accentro:mapCookieHeading')}</h3>
          <p className="description-text">{t('accentro:mapCookieParagraph')}</p>
          <p className="not-existing-service">
            {t('accentro:mapCookieNotExistingService')}
          </p>

          <div className="uc-embedding-buttons">
            <button
              onTouchStart={() => {
                // @ts-ignore: Cannot find name (uc is defined in external script)
                uc.ucapi.showInfoModal('S1pcEj_jZX|iVTAGV51C')
                return false
              }}
              onClick={() => {
                // @ts-ignore: Cannot find name (uc is defined in external script)
                uc.ucapi.showInfoModal('S1pcEj_jZX|iVTAGV51C')
                return false
              }}
              className="uc-embedding-more-info"
            >
              {t('accentro:mapCookieMoreInfo')}
            </button>
            <button
              onTouchStart={() => {
                // @ts-ignore: Cannot find name (uc is defined in external script)
                uc.ucapi.setConsents([
                  { templateId: 'S1pcEj_jZX|iVTAGV51C', status: true },
                ])
              }}
              onClick={() => {
                // @ts-ignore: Cannot find name (uc is defined in external script)
                uc.ucapi.setConsents([
                  { templateId: 'S1pcEj_jZX|iVTAGV51C', status: true },
                ])
              }}
              className="uc-embedding-accept"
            >
              {t('accentro:mapCookieAccept')}
            </button>
          </div>
          <span>
            powered by{' '}
            <a
              target="_blank"
              rel="noreferrer"
              className="uc-embedding-powered-by"
              href="https://usercentrics.com/"
            >
              Usercentrics Consent Management Platform
            </a>
          </span>
        </div>
      </MapPlaceholder>
    )
  } else {
    return (
      <div
        tw="height[467px] md:(height[375px]) ml:(height[567px])"
        className="google-maps"
      >
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={center}
          zoom={15}
          options={{
            styles: mapStyle,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: false,
            fullscreenControl: false,
          }}
        >
          <>{children}</>
        </GoogleMap>
      </div>
    )
  }
}
// export const MyMap = memo(MyMapNonMemo)
export const MyMap = MyMapNonMemo
